import { useI18n } from "#hooks/use-i18n"
import { Plus } from "lucide-react"
import { Button } from "../ui/button"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip"

interface CategoriesHeaderActionsProps {
  onCreateCategory: () => void
  isOwner: boolean
}

export function CategoriesHeaderActions({
  onCreateCategory,
  isOwner,
}: CategoriesHeaderActionsProps) {
  const { t } = useI18n()
  const button = (
    <Button
      onClick={isOwner ? onCreateCategory : undefined}
      disabled={!isOwner}
      className="w-full sm:w-auto shadow-sm dark:shadow-none dark:border-border/50 hover:shadow-md dark:hover:shadow-none transition-shadow"
    >
      <Plus className="w-5 h-5 mr-2" />
      {t("pages.categories.form.create")}
    </Button>
  )

  if (isOwner) {
    return button
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>{button}</span>
      </TooltipTrigger>
      <TooltipContent>
        <p>{t("components.categories.headerActions.actionDisabled")}</p>
      </TooltipContent>
    </Tooltip>
  )
}
